export const reduxKey = '@@deviationPopup';
export const actionKey = '@@deviationPopup';
